import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { MessageSquare } from "lucide-react";

interface FeedbackItem {
  category: string;
  rating: string;
  feedback: string;
}

interface ConsumerFeedbackTableProps {
  feedbackItems: FeedbackItem[];
}

export default function ConsumerFeedbackTable({
  feedbackItems,
}: ConsumerFeedbackTableProps) {
  return (
    <Card className="shadow-lg h-full border border-slate-200 rounded-xl overflow-hidden">
      <CardHeader className="pb-3 pt-5 px-6 bg-slate-50 border-b border-slate-200">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <MessageSquare size={20} className="text-indigo-600" />
          Consumer Feedback
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-slate-300 bg-slate-100">
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500 w-[150px]">Category</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500 text-center w-[100px]">
                Rating
              </TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">Feedback</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {feedbackItems.map((item, index) => (
              <TableRow key={index} className="border-t border-slate-200 hover:bg-slate-50 transition-colors">
                <TableCell className="p-4 align-middle text-base font-medium text-slate-700">
                  {item.category}
                </TableCell>
                <TableCell className="p-4 align-middle text-base text-center text-slate-600">{item.rating}</TableCell>
                <TableCell className="p-4 align-middle text-base text-slate-600">{item.feedback}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
